module.exports = __webpack_public_path__ + "img/vpn.a1f75f3d.webp";